export default value => value && value.includes(' ') ?
  'Spaces not allowed' : undefined
